import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { productAlertOverridesAlertIdCanvasIdCacheKeys } from "./constants";
import type { PutProductAlertOverridesAlertIdCanvasIdProps } from "./types";

/** Excludes the Canvas from one app group alert, or includes it again. */
export const putProductAlertOverridesAlertIdCanvasId = reactQueryMutationAdapter(
  productAlertOverridesAlertIdCanvasIdCacheKeys,
  ({ alertId, canvasId, enabled }: PutProductAlertOverridesAlertIdCanvasIdProps): Promise<void> => {
    return fetch(`/product_alerts/overrides/${alertId}/${canvasId}`, "PUT", { enabled }, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
